import type { TVehicleType } from '@/hooks/api/ads-listing';

/**
 * Placeholder "SEM FOTO" — mesmo asset usado na Garagem atual (legado), por
 * pedido do QA. Carro e moto têm imagens distintas (espelha config.urlSemFoto*).
 */
export const SEM_FOTO_IMAGE_URL: Record<TVehicleType, string> = {
	car: 'https://cdn.webmotors.com.br/webmotors/Content/assets/img/resultado-busca/anuncio_semfoto.png',
	bike: 'https://cdn.webmotors.com.br/webmotors/Content/assets/img/resultado-busca/anuncio_moto_semfoto.png',
};
